import type { UseGetAirportsByNameQueryParams } from './search-by-name.query.js'

export const airportKeys = {
  all: ['airports'] as const,
  byIataCode: (iataCode: string) => ['airports', 'by-iata-code', iataCode] as const,
  bySearchParam: (searchParam: string) => ['airports', 'search', searchParam] as const,
  countryCities: (countryCode: string) => ['airports', 'country-cities', countryCode] as const,
  countrySuggestions: ['airports', 'country-suggestions'] as const,
  defaultSuggestions: (mode: string) => ['airports', 'default-suggestions', mode] as const,
  list: (params: UseGetAirportsByNameQueryParams) => ['airports', 'list', params] as const,
  stats: ['stats', 'airports'] as const,
}
